// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1tl18","loaderOuter":"PageOverlayLoader_loaderOuter__26L9Q"};